import HeaderNav from "components/components/HeaderNav/HeaderNav";
import PageMeta from "components/components/Meta/PageMeta";
import React from "react";

import {
  Description,
  Header,
  LinkDescription,
  LinksGrid,
  LinkItem,
  PageWithLeftBar,
  StyledArrowLink,
  Title,
} from "./style";

export type SectionLandingLink = {
  title: string;
  to: string;
  description: string;
};

type Props = {
  title: string;
  description: React.ReactNode;
  links: SectionLandingLink[];
};

const SectionLandingPage: React.FC<Props> = ({
  title,
  description,
  links,
}: Props) => (
  <>
    <PageMeta title={title} />
    <HeaderNav title={title} />
    <PageWithLeftBar>
      <Header>
        <Title>{title}</Title>
        <Description>{description}</Description>
      </Header>

      <LinksGrid>
        {links.map((link) => (
          <LinkItem key={link.to}>
            <StyledArrowLink
              to={link.to}
              isInternalDestination={true}
              text={link.title}
              textFirst
            />
            <LinkDescription>{link.description}</LinkDescription>
          </LinkItem>
        ))}
      </LinksGrid>
    </PageWithLeftBar>
  </>
);

export default SectionLandingPage;
